import { render, staticRenderFns } from "./WritingBlankType4.vue?vue&type=template&id=cee71200&scoped=true&"
import script from "./WritingBlankType4.vue?vue&type=script&lang=js&"
export * from "./WritingBlankType4.vue?vue&type=script&lang=js&"
import style0 from "./WritingBlankType4.vue?vue&type=style&index=0&id=cee71200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee71200",
  null
  
)

export default component.exports